import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import AccionaTableDeliveryROW from './AccionaTableDeliveryROW';
import AccionaTableDeliveryButton from './AccionaTableDeliveryButton.jsx';
import { getFile } from '../../../../../../../services/api/files';
import moment from 'moment';
import generatePDF from './generatePDF';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import AccionaButton from '../../../../../../../components/AccionaButton/index.jsx';

const AccionaTableDelivery = ({
  formState,
  viewAction,
  camViewAction,
  camFileName,
  fileName,
  workCode,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [scannedDocket, setScannedDocket] = useState(false);
  const [photoDocket, setPhotoDocket] = useState(false);
  const { model } = useParams();
  const { me } = useSelector(({ auth }) => auth);

  const onBack = () => navigate(-1);
  const pdfName = `${workCode}_ALBARAN_${formState.docket_number}_${moment(
    new Date(),
  ).format('YYYYMMDD')}`;

  useEffect(() => {
    const getPhotoDocket = async () => {
      const { data } = await getFile(
        camFileName,
        model === 'deliveryPC' ? 'deliveryPC' : 'delivery',
      );
      setPhotoDocket(URL.createObjectURL(data));
    };
    if (!scannedDocket) {
      if (camFileName) getPhotoDocket();
    }
  }, [camFileName, model, scannedDocket]);

  useEffect(() => {
    const getScannedDocket = async () => {
      const { data } = await getFile(
        fileName,
        model === 'deliveryPC' ? 'deliveryPC' : 'delivery',
      );
      setScannedDocket(URL.createObjectURL(data));
    };
    if (!scannedDocket) {
      getScannedDocket();
    }
  }, [fileName, model, scannedDocket]);

  return (
    <div className="wrapper">
      <div className="form-row">
        <AccionaButton
          msg={intl.formatMessage({ id: 'back' })}
          onClick={onBack}
          classIcon="icon fas fa-chevron-left"
          style={{ float: 'right', marginTop: '30px', marginRight: '0px' }}
        />
        <AccionaButton
          msg={intl.formatMessage({ id: 'generatePDF' })}
          disabled={!me.is_active}
          classIcon="icon fas fa-file-invoice"
          style={{ float: 'left', marginTop: '30px', marginLeft: '0px' }}
          onClick={() => {
            generatePDF({
              formState,
              scannedDocket,
              photoDocket,
              fileName: pdfName,
              model,
            });
          }}
        ></AccionaButton>
      </div>
      <div className="card no-padding no-margin" id="AccionaTable">
        <div className="dataTables_wrapper no-footer">
          <table
            className="dataTable"
            style={{ backgroundColor: '#fff', border: '1px solid #f1f1f1' }}
          >
            <tbody id="AccionaTableBody">
              <AccionaTableDeliveryROW
                text_align="center"
                datas={{ supplier_id: formState.supplier_id }}
              />

              <AccionaTableDeliveryROW
                text_align="center"
                datas={{
                  attr_docket_number: formState.docket_number,
                  attr_plant: formState.plant,
                  attr_arriving_date: formState.arriving_date,
                }}
              />

              <AccionaTableDeliveryROW
                text_align="center"
                datas={{
                  attr_recipe: formState.recipe,
                  attr_delivered: formState.delivered,
                }}
              />

              <AccionaTableDeliveryROW
                text_align="center"
                datas={{
                  attr_requester: formState.requester,
                  attr_ocr_destination: formState.ocr_destination,
                }}
              />
              <AccionaTableDeliveryROW
                text_align="center"
                datas={{
                  elements:
                    formState.elements?.length > 1
                      ? formState.elements
                          .split(',')
                          .map((element) => intl.formatMessage({ id: element }))
                      : [],
                }}
              />
              <AccionaTableDeliveryROW
                text_align="center"
                datas={{ detailed_location: formState.detailed_location }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  attr_delivery_company: formState.delivery_company,
                  attr_concrete_id: formState.concrete_id,
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  attr_truck: formState.truck,
                  attr_compound: formState.compound,
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  attr_driver: formState.driver,
                  attr_relation_wc: formState.relation_wc,
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  attr_delivery_company_cif: formState.delivery_company_cif,
                  none: 'none',
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  none: 'none',
                  attr_admixtures_id: formState.admixtures_id,
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  attr_manufacture_time: formState.manufacture_time,
                  attr_admixtures_quantity: formState.admixtures_quantity,
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{ arriving_time: formState.arriving_time, none: 'none' }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  start_discharging_time: formState.start_discharging_time,
                  attr_admixtures_extra: formState.admixtures_extra,
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{
                  finish_discharging_time: formState.finish_discharging_time,
                  none: 'none',
                }}
              />

              <AccionaTableDeliveryROW
                type="2"
                datas={{ attr_limit_time: formState.limit_time, none: 'none' }}
              />

              {model === 'delivery' && (
                <AccionaTableDeliveryROW
                  text_align="center"
                  datas={{
                    mash_control: formState.mash_control,
                    specimens_number: formState.specimens_number,
                    slump: formState.slump,
                  }}
                />
              )}

              <AccionaTableDeliveryButton
                viewAction={viewAction}
                camViewAction={camViewAction}
                camFileName={camFileName}
                thereIsScannedDocket={!scannedDocket}
              />
            </tbody>
          </table>
        </div>
      </div>
      <div className="form-row">
        <AccionaButton
          msg={intl.formatMessage({ id: 'back' })}
          onClick={onBack}
          classIcon="icon fas fa-chevron-left"
          style={{ float: 'right', marginTop: '30px', marginRight: '0px' }}
        />
        <AccionaButton
          msg={intl.formatMessage({ id: 'generatePDF' })}
          disabled={!me.is_active}
          classIcon="icon fas fa-file-invoice"
          style={{ float: 'left', marginTop: '30px', marginLeft: '0px' }}
          onClick={() => {
            generatePDF({
              formState,
              scannedDocket,
              photoDocket,
              fileName: pdfName,
              model,
            });
          }}
        ></AccionaButton>
      </div>
    </div>
  );
};

AccionaTableDelivery.propTypes = {
  formState: PropTypes.object.isRequired, // TODO: Complete with shape()
  viewAction: PropTypes.func.isRequired,
  camViewAction: PropTypes.func.isRequired,
  camFileName: PropTypes.string,
  fileName: PropTypes.string.isRequired,
  workCode: PropTypes.string.isRequired,
};

AccionaTableDelivery.defaultProps = {
  camFileName: undefined,
};

export default AccionaTableDelivery;
